import makeAjaxRequest from './make-ajax-request';
var loadSvgUncached = function (url, httpRequestWithCredentials, callback) {
    makeAjaxRequest(url, httpRequestWithCredentials, function (error, httpRequest) {
        var _a;
        if (error) {
            callback(error);
        }
        else if (((_a = httpRequest.responseXML) === null || _a === void 0 ? void 0 : _a.documentElement) instanceof SVGSVGElement) {
            callback(null, httpRequest.responseXML.documentElement);
        }
    });
};
export default loadSvgUncached;
//# sourceMappingURL=load-svg-uncached.js.map